module.exports = __webpack_public_path__ + "media/bootstrap-icons/box-arrow-in-right-98938f51.svg";